var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCar = function SvgCar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: 24,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.739 10.921A51.347 51.347 0 0 0 18.187 10s-2.379-2.359-2.832-2.816C14.787 6.612 14.312 6 12.406 6H4.512c-.511 0-.736.547-.07 1a30.018 30.018 0 0 0-2.258 2.027C.749 10.482 0 11.412 0 13.282 0 15.042 1.042 17 3.174 17h.01A2.992 2.992 0 0 0 6 19a2.992 2.992 0 0 0 2.816-2h6.367c.413 1.162 1.512 2 2.816 2s2.403-.838 2.816-2h.685c1.994 0 2.5-1.776 2.5-3.165 0-2.041-1.123-2.584-2.261-2.914zM6 17.2a1.201 1.201 0 0 1 0-2.4 1.201 1.201 0 0 1 0 2.4zM9.576 11c-1.071 0-3.5-.106-5.219-.75.578-.75.998-1.222 1.27-1.536A2.09 2.09 0 0 1 7.188 8h2.388v3zm1-3h1.835c.882 0 1.428.493 2.022 1.105.452.466 1.732 1.895 1.732 1.895h-5.588V8zM18 17.2a1.201 1.201 0 0 1 0-2.4 1.201 1.201 0 0 1 0 2.4z"
  })));
};

export default SvgCar;